module.exports = __webpack_public_path__ + "img/percentage.7354e554.svg";